import { Injectable } from '@angular/core';
import { Storage } from '@ionic/storage';
const VIEWED_KEY = 'viewed_product';
const MAX_LIST = 50;
@Injectable()
export class ViewedproductProvider {
    ids: number[] = [];
    isLoad: boolean = false;
    constructor(
        public storage: Storage
    ) {
        this.init();
    }

    init() {
        console.log('Init here');
        this.getProducts().then(result => {
            if (result) {
                this.ids = result;
                this.isLoad = true;
            }
        });
    }
    getViewedProduct(): Promise<any> {
        if (this.isLoad) {
            return Promise.resolve(this.ids);
        }
        else {
            return this.getProducts().then(result => {
                if (result) {
                    this.ids = result;
                    this.isLoad = true;
                    return this.ids;
                }
            });
        }
    }
    getProducts() {
        return this.storage.get(VIEWED_KEY);
    }

    add(id: number) {
        if (this.ids.indexOf(id) === -1) {
            this.ids.unshift(id);
            if (this.ids.length > MAX_LIST) {
                this.ids.pop();
            }
            return this.storage.set(VIEWED_KEY, this.ids);
        }
    }

}



// WEBPACK FOOTER //
// ./src/providers/viewedproduct/viewedproduct.ts